export default __webpack_public_path__ + "static/media/logo_main.3c27a5ce.png";